export function openInBrowserWindow(url: string): void {
  try {
    Office.context.ui.openBrowserWindow(url);
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
